import React from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = () => {
  return !!localStorage.getItem('authToken'); 
};

const PrivateRoute = ({ element }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" />;
  }
  return element;
};

export default PrivateRoute;
